import { ProjectPhase, Project } from '@mb/lib';

export enum LocalStorageKey {
  MAGE_CACHE_STORAGE = 'mage-cache-storage',
  SELECT_PROJECT_TIMESTAMP = 'select-project-timestamp',
  RECOMMENDATIONS_MODAL_SETTINGS = 'recommendations-modal-settings',
  CONTACT_REPRESENTATIVE_MODAL = 'contactRep',
}

export const getMageCacheStorage = () => {
  return JSON.parse(
    localStorage.getItem(LocalStorageKey.MAGE_CACHE_STORAGE) || '{}',
  );
};

export const getUserAttributes = () => {
  const mageCacheStorage = getMageCacheStorage();

  return mageCacheStorage?.customer;
};

export const getDirectoryData = () => {
  const mageCacheStorage = getMageCacheStorage();

  return mageCacheStorage?.['directory-data'];
};

export const setProjectDataToMageStorage = (
  currentProject: Project,
  projectPhases: ProjectPhase[],
): void => {
  let localStorageObject = { customer: {} };

  try {
    // try fetch localStorage data
    localStorageObject = getMageCacheStorage();
    // check if customer exist
    if (!localStorageObject.customer) {
      localStorageObject.customer = {};
    }
  } catch (error) {
    console.error('setProjectDataToMageStorage failed', error);
    localStorageObject = { customer: {} };
  }

  localStorageObject.customer = {
    ...localStorageObject.customer,
    current_project: String(currentProject.project_id),
    current_project_name: currentProject.project_title,
    current_project_type: String(currentProject.project_type),
    current_project_location: String(currentProject.project_location),
    current_project_phase_id: String(currentProject.phase_id),
    current_project_phase_name: projectPhases?.find(
      (item: ProjectPhase) =>
        String(item?.phase_id) === String(currentProject.phase_id),
    )?.phase_name,
  };

  localStorage.setItem(
    LocalStorageKey.MAGE_CACHE_STORAGE,
    JSON.stringify(localStorageObject),
  );
};
